// Stable per-browser device identifier.
//
// Guest usage limits (the "5 free questions" on_Ask, the_notes_quota, etc.)
// are enforced server-side, but for unauthenticated visitors there is no user
// account to key the counter on. Sending a stable device id lets the backend
// bind the limit to (ip, device) so it can't be trivially bypassed by clearing
// app state / opening a fresh session. The actual enforcement still happens on
// the server — this id is only the client-side half of that binding.

const STORAGE_KEY = "uniui_device_id";

export function getDeviceId(): string {
  if (typeof window === "undefined") return "server";
  try {
    let id = window.localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : `dev_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      window.localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    // Storage unavailable (private mode, etc.) — fall back to a session-only id.
    return "anonymous";
  }
}
